/** LittleLens presentation slide background tokens */
export const presentationBackground = {
  primary: '#49B9D9',
  primaryDark: '#269BB2',
  primaryLight: '#7ED5EA',
  circleLight: 'rgba(126, 218, 240, 0.58)',
  circleTeal: 'rgba(38, 158, 178, 0.74)',
  sidebarGradient: 'linear-gradient(135deg, #49B9D9 0%, #269BB2 100%)',
  pageTitle: '#ffffff',
  pageSubtitle: 'rgba(255, 255, 255, 0.88)',
} as const;
